"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.show = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importStar(require("react-dom"));
var ModalMain_1 = require("./ModalMain");
var configprovider_1 = require("../configprovider");
/**
 * API 方式唤起一个对话框内容
 */
function show(options) {
    var el = document.createElement("div");
    var instanceRef = react_1.default.createRef();
    react_dom_1.default.render(react_1.default.createElement(configprovider_1.ConfigProvider, null,
        react_1.default.createElement(ModalShow, tslib_1.__assign({}, options, { ref: instanceRef, onExited: function () { return react_dom_1.unmountComponentAtNode(el); } }))), el);
    return {
        destroy: function () {
            if (instanceRef.current) {
                instanceRef.current.setVisible(false);
            }
        },
    };
}
exports.show = show;
var ModalShow = react_1.forwardRef(function ModalShow(props, ref) {
    var _a = tslib_1.__read(react_1.useState(false), 2), visible = _a[0], setVisible = _a[1];
    // 渲染之后，马上显示
    react_1.useEffect(function () {
        setVisible(true);
    }, []);
    // 实例 ref 到外部
    react_1.useImperativeHandle(ref, function () { return ({ setVisible: setVisible }); });
    return react_1.default.createElement(ModalMain_1.Modal, tslib_1.__assign({}, props, { visible: visible }));
});
//# sourceMappingURL=ModalShow.js.map